export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13875.257a26fd.jpg";